import React from "react";
import "./fireTable.css";


export const FireTable = ({i18n}) => {

    const fireData = [
        {
            name: i18n.FireTable_Green_Name,
            background: i18n.FireTable_Green_Hex,
            textColor: i18n.FireTable_Black_Text,
            description: i18n.FireTable_Green_Description
        },
        {
            name: i18n.FireTable_Yellow_Name,
            background: i18n.FireTable_Yellow_Hex,
            textColor: i18n.FireTable_Black_Text,
            description: i18n.FireTable_Yellow_Description
        },
        {
            name: i18n.FireTable_Red_Name,
            background: i18n.FireTable_Red_Hex,
            textColor: i18n.FireTable_White_Text,
            description: i18n.FireTable_Red_Description
        },
        {
            name: i18n.FireTable_White_Name,
            background: i18n.FireTable_White_Hex,
            textColor: i18n.FireTable_Black_Text,
            description: i18n.FireTable_White_Description,
        },
    ];

    return (
        <table className="dataTable">
            <thead>
            <tr>
                <th>
                    {i18n.FireTable_Color}
                </th>
                <th>
                    {i18n.FireTable_Potential_Contribution}
                </th>
            </tr>
            </thead>
            <tbody>
            {fireData.map((item, index) => (
                <tr
                    key={index}
                    style={{ backgroundColor: item.background, color: item.textColor }}
                >
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                </tr>
            ))}
            </tbody>
        </table>
    );
};
